import React from 'react';
import { Message } from '@doveit/bricks';
import { CreateAgencyWizardStepProps } from '../types';
import { commissionsToCommissionsFormModel } from '../../../../agent/containers/edit-agent-commissions-action/mappers';
import { commissionFormModelToAgency } from '../../upsert-agency-commissions-action/mappers';
import CommissionsForm, { CommissionsFormModel } from '../../../../agent/components/commissions-form/CommissionsForm';

const AgencyCommissionsWizardStep: React.FC<CreateAgencyWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const onInternalSubmit = React.useCallback((formValues: CommissionsFormModel) => {
    if (!initialData) return;

    const isFormDirty = (formRef?.current as any)?.dirty ?? false;
    const data = commissionFormModelToAgency(formValues, initialData);
    onSubmit(data, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  if (!initialData) return null;

  if (!initialData.franchising) {
    return (
      <Message message="Le provvigioni sono previste nel caso di agenzie di tipo franchising." />
    );
  }

  return (
    <CommissionsForm
      initialValues={
        initialData.commissions
          ? commissionsToCommissionsFormModel(initialData.commissions)
          : undefined
      }
      innerRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AgencyCommissionsWizardStep;
